import LogRocket from "logrocket";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import UnsupportedDevice from "./Components/UnsupportedDevice/UnsupportedDevice";
import "./index.css";
import store, { persistor } from "./Redux/store";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { isLocalhost } from "./Utils/Constants/Constants";
import * as Sentry from "@sentry/react";

if (
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1" &&
  process.env.REACT_APP_SENTRY_KEY
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_STAGING
  });
}

// eslint-disable-next-line new-parens
((g) => {
  var h,
    a,
    k,
    p = "The Google Maps JavaScript API",
    c = "google",
    l = "importLibrary",
    q = "__ib__",
    m = document,
    b = window;
  b = b[c] || (b[c] = {});
  var d = b.maps || (b.maps = {}),
    r = new Set(),
    e = new URLSearchParams(),
    u = () =>
      h ||
      (h = new Promise(async (f, n) => {
        await (a = m.createElement("script"));
        e.set("libraries", [...r] + "");
        for (k in g)
          e.set(
            k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
            g[k]
          );
        e.set("callback", c + ".maps." + q);
        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
        d[q] = f;
        a.onerror = () => (h = n(Error(p + " could not load.")));
        a.nonce = m.querySelector("script[nonce]")?.nonce || "";
        m.head.append(a);
      }));
  d[l]
    ? console.warn(p + " only loads once. Ignoring:", g)
    : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
})({
  key: (() => {
    if (window.Cypress) {
      return true;
    } else if (
      window.location.hostname === "localhost" &&
      window.Location.pathname === "maps"
    ) {
      return true;
    } else {
      return false;
    }
  })
    ? process.env.REACT_APP_MAP_KEY
    : "",
  v: "weekly"
});

ReactDOM.render(
  <ErrorBoundary
    onClick={() => {
      localStorage.clear();
      window.location.reload();
    }}
    handleComponentDidCatch={(error) => {
      LogRocket.captureMessage(error.message, {
        tags: {
          userType: "admin"
        },
        extra: {
          fatal: true,
          code: error.code
        }
      });
    }}
  >
    <React.StrictMode>
      <BrowserRouter
        future={{
          v7_startTransition: true
        }}
      >
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            {(isLocalhost && !window.Cypress) ||
            !navigator.userAgent.includes("Mobile") ? (
              <App />
            ) : (
              <UnsupportedDevice />
            )}
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);

if (window.Cypress) {
  window.store = store;
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.unregister();
}

// const skipWaitingClearCacheAndReload = async () => {
//   navigator.serviceWorker.addEventListener("message", (event) => {
//     if (event.data === "FORCE_UPDATE_COMPLETE") {
//       window.location.reload(true);
//     }
//   });

//   navigator.serviceWorker.ready.then((registration) => {
//     registration.waiting.postMessage("FORCE_UPDATE");
//   });
// };

// async function onSWUpdate(controller, force) {
//   if (force === true && controller) {
//     const criticalUpdateCard = document.getElementById("critical-update-card");
//     criticalUpdateCard.classList.remove("display-none");
//     criticalUpdateCard.classList.add("display-block");
//     const criticalUpdateButton = document.getElementById(
//       "critical-update-confirm-button"
//     );
//     criticalUpdateButton.addEventListener("click", () =>
//       skipWaitingClearCacheAndReload()
//     );
//   }
// }

reportWebVitals();
